import _isEmpty from "lodash/isEmpty";
import { ORGANIZATION } from '../constants';
import { extractStructuredContent } from '../utils';
/*
 * Get the schema for FAQPage
 *
 * @param  {Array}  faqSections An array of objects representing questions and answers eg:
 *                              [
 *                                { question: <String>, answer: <String> },
 *                                ...
 *                              ]
 *
 * @return {Object} FAQPage schema
 */

export var getFaqSchema = function getFaqSchema(faqSections) {
  if (_isEmpty(faqSections)) {
    return null;
  }

  return {
    '@type': 'FAQPage',
    mainEntity: faqSections.map(function (_ref) {
      var answer = _ref.answer,
          question = _ref.question;
      return {
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: extractStructuredContent(answer)
        }
      };
    })
  };
};
/*
 * Get the schema for Organization
 *
 * @return {Object} Organization schema
 */

export var getOrganizationSchema = ORGANIZATION;
/**
 * Given a rating, return the schema for the reviewRating property.
 *
 * @param  {Number} ratingValue - Rating value.
 * @param  {Number} options.bestRating  - Best possible rating (optional).
 *
 * @return {Object}             - Schema for reviewRating property.
 */

export var getReviewRatingSchema = function getReviewRatingSchema(ratingValue) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$bestRating = _ref2.bestRating,
      bestRating = _ref2$bestRating === void 0 ? 5 : _ref2$bestRating;

  return {
    '@type': 'Rating',
    worstRating: 0,
    bestRating: bestRating,
    ratingValue: ratingValue
  };
};
/**
 * Get the minimum schema we need to achieve star ratings on SERPs.
 *
 * Note: When we have a fuller Review schema object to output it's better to
 * use that. This schema is optimized for specifically achieving star ratings
 * on search engine result pages while requiring as few inputs as possible.
 *
 * @param  {string} productName - Name of the product the rating applies to.
 * @param  {string|int} rating  - The rating value, out of 5.
 * @param  {string} author      - Name of the author of the rating.
 *
 * @return {Object|null}        - Schema data object, or null.
 */

export var getMinimumStarRatingOnSERPsSchema = function getMinimumStarRatingOnSERPsSchema(productName, rating, author) {
  if (!productName || !rating || !author) {
    return null;
  }

  return {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: productName,
    review: {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: author
      },
      reviewRating: getReviewRatingSchema(rating)
    }
  };
};